import { useMemo } from "react";

import { useSelector } from "react-redux";
import { setResources, textColor } from "./helpers";
import { OPTIONS_BY_LABEL } from "./constants";
import ResourceLauncher from "./ResourceLauncher";
import { useAppLinks, useFeatureFlags } from "../../../reducers/layoutReducer/selectors";

const AppsResources = () => {
  const theme = useSelector(({ layout }) => layout.theme.name);
  const isAdmin = useSelector(({ layout }) => layout.currentUser.account.isAdmin);
  const isOwner = useSelector(({ layout }) => layout.currentUser.account.isOwner);
  const appOptions = useSelector(({ layout }) => layout.apps);
  const appLinks = useAppLinks();
  const featureFlags = useFeatureFlags();

  // returns array of furnished {linkURL, Icon, label} for resourceLaunchers
  const resources = useMemo(() => {
    const rsrc = setResources({ theme, isAdmin, isOwner });

    const optionsByHeadline = appOptions.reduce(
      (acc, { headline, launchUrl }) => ({
        ...acc,
        [headline]: launchUrl,
      }),
      {},
    );

    return rsrc
      .filter(({ label }) => {
        if (label === "Gabbi Call IQ" && !featureFlags.aiCallCoaching) return false;
        if (label === "AreaPro" && !featureFlags.areaproUser) return false;
        return true;
      })
      .map(({ label, linkUrl, ...rest }) => ({
        ...rest,
        linkUrl: optionsByHeadline[OPTIONS_BY_LABEL[label]] || linkUrl,
        label,
      }));
  }, [theme, isAdmin, isOwner, appOptions]);

  return (
    <div className="tw-p-[16px]">
      <div className="tw-flex tw-justify-between tw-items-center tw-mb-8px">
        <span className={textColor(theme)}>Apps</span>
      </div>
      <div className="tw-flex tw-justify-between tw-over tw-flex-wrap">
        {resources.map(({ Icon, label, linkUrl }) => (
          <ResourceLauncher
            enabled={label !== "Remine" || Boolean(appLinks?.find((app) => app.label === label))}
            Icon={Icon}
            label={label}
            linkUrl={linkUrl}
            key={label}
          />
        ))}
      </div>
    </div>
  );
};

export default AppsResources;
